import axios from 'axios'
import {
	Message,
	MessageBox
} from 'element-ui'
import store from '../store'
import {
	getToken
} from '@/utils/auth'
import Cookies from 'js-cookie';

// 创建axios实例
const service = axios.create({
	baseURL: process.env.BASE_API, // api的base_url
	// timeout: 60000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
	if (store.getters.token) {
		config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
	}
	config.params = config.params || {}
	config.data = config.data || {}
	if (Cookies.get('roleType') && Cookies.get('roleType') != 1 && Cookies.get('roleType') != 2 && !config.url
		.includes(
			'/admin/stationUser/organizationStation') && !config.url.includes('/admin/works/orderPage') && !config.url
		.includes('/admin/works/vehiclePage') && !config.url.includes('/api/userDrivers/userDriverPage')) {
		if (Cookies.get('roleType') == 3 && config.url.includes('/admin/branks/bankPage')) {} else {
			let stationId = Cookies.get('stationId')
			console.log(stationId, "stationId")
			config.params['stationId'] = stationId ? stationId : 0
			config.data['stationId'] = stationId ? stationId : 0
		}
	}
	return config
}, error => {
	// Do something with request error
	console.log(error) // for debug
	Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
	response => {
		/**
		 * code为非200是抛错 可结合自己业务进行修改
		 */
		const res = response.data
		if (res.code !== 1000) {
			if (response.config.url.indexOf('/api/users/frontLoginDeleted') != -1) {
				MessageBox.confirm(res.message, '提示', {
					confirmButtonText: '确定'
				})
			} else {
				Message({
					message: res.message,
					type: 'error',
					duration: 3 * 1000
				})
			}
			// 403:未登录;
			if (res.code === 403) {
				MessageBox.confirm('你没有权限访问该功能', '确定登出', {
					confirmButtonText: '重新登录',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					store.dispatch('FedLogOut').then(() => {
						location.reload() // 为了重新实例化vue-router对象 避免bug
					})
				})
			}
			// 401:未登录;
			if (res.code === 401) {
				MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
					confirmButtonText: '重新登录',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					store.dispatch('FedLogOut').then(() => {
						location.reload() // 为了重新实例化vue-router对象 避免bug
					})
				})
			}
			return Promise.reject('error')
		} else {
			return response.data
		}
	},
	error => {
		console.log('err' + error) // for debug
		Message({
			message: error.message,
			type: 'error',
			duration: 3 * 1000
		})
		return Promise.reject(error)
	}
)

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js